/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  ICellRendererParams,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import { Box, Stack } from '@atgfr8/atg-ui-tailwind';
import { ILoadBoardViewModel } from '@store/loadboard';
import {
  VirusIcon,
  TruckIcon,
  AccountMultipleOutlineIcon,
  RulerIcon,
  DropTrailerIcon,
} from '@atgfr8/icons';
import { ToolTip } from '@views/carrierMatching/ToolTip';
import { createMemo, JSX, Show } from 'solid-js';
type PropsT = {
  type: 'team' | 'hazmat' | 'tarp' | 'overDimensions' | 'ramps' | 'dropTrailer';
};
type PiecesT = [JSX.Element, string];

const AccessorialIcon = (props: PropsT) => {
  const pieces = createMemo(() => {
    switch (props.type) {
      case 'team':
        return [<AccountMultipleOutlineIcon />, 'Team Required'] as PiecesT;
      case 'hazmat':
        return [<VirusIcon />, 'Hazmat Required'] as PiecesT;
      case 'tarp':
        return [<TruckIcon />, 'Tarp Required'] as PiecesT;
      case 'overDimensions':
        return [<RulerIcon />, 'Over Dimension'] as PiecesT;
      case 'ramps':
        return [
          <RulerIcon style={{ transform: 'rotate(270deg)' }} />,
          'Ramps Required',
        ] as PiecesT;
      case 'dropTrailer':
        return [<DropTrailerIcon />, 'Drop Trailer'] as PiecesT;
      default:
        return [<></>, '-'] as PiecesT;
    }
  });

  return (
    <ToolTip anchor={pieces()[0]}>
      <Box>{pieces()[1]}</Box>
    </ToolTip>
  );
};

export const AccessorialsCellRenderer = (
  data: ICellRendererParams<ILoadBoardViewModel>,
) => {
  return (
    <Stack direction="row" gap={0.4}>
      <Show when={data.data?.teamRequired} fallback={<></>}>
        <AccessorialIcon type="team" />
      </Show>
      <Show when={data.data?.hazmatRequired} fallback={<></>}>
        <AccessorialIcon type="hazmat" />
      </Show>
      <Show when={data.data?.tarpRequired} fallback={<></>}>
        <AccessorialIcon type="tarp" />
      </Show>
      <Show when={data.data?.overDimension} fallback={<></>}>
        <AccessorialIcon type="overDimensions" />
      </Show>
      <Show when={data.data?.rampsRequired} fallback={<></>}>
        <AccessorialIcon type="ramps" />
      </Show>
      <Show when={data.data?.dropTrailer} fallback={<></>}>
        <AccessorialIcon type="dropTrailer" />
      </Show>
    </Stack>
  );
};

export const accessorialArrayValue = (
  param: ValueGetterParams | ValueFormatterParams,
): string[] => {
  const data = param.node?.data as ILoadBoardViewModel | null;
  const accessorials: string[] = [];

  if (!!data?.teamRequired) {
    accessorials.push('Team');
  }

  if (!!data?.hazmatRequired) {
    accessorials.push('Hazmat');
  }

  if (!!data?.tarpRequired) {
    accessorials.push('Tarp');
  }

  if (!!data?.overDimension) {
    accessorials.push('Over Dimension');
  }

  if (!!data?.rampsRequired) {
    accessorials.push('Ramps');
  }
  if (!!data?.dropTrailer) {
    accessorials.push('Drop Trailer');
  }
  return accessorials;
};

export const accessorialList = [
  'Team',
  'Hazmat',
  'Tarp',
  'Over Dimension',
  'Ramps',
  'Drop Trailer',
];
